
import { useEffect, useState, useRef } from 'react';

const ScrollToTop = () => {
  const [progress, setProgress] = useState(0);
  const [isBottom, setIsBottom] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const rafRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {

      const el = document.scrollingElement || document.documentElement;
      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      const docHeight = Math.max(1, scrollHeight - clientHeight);
      const percent = Math.min(100, Math.max(0, (scrollTop / docHeight) * 100));


      const atBottom = scrollTop + clientHeight >= scrollHeight - 2;

      setProgress(percent);
      setIsBottom(atBottom);
      setIsVisible(scrollTop > 200);
    };


    const onScrollRaf = () => {
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        onScroll();
        rafRef.current = null;
      });
    };

    window.addEventListener('scroll', onScrollRaf, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScrollRaf);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const handleClick = () => {

    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch {
      window.scrollTo(0, 0);
    }
  };


  const size = 44;
  const strokeWidth = 3;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (progress / 100) * circumference;


  const gradBg =
    'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)';

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      aria-label="العودة للأعلى"

      className="fixed z-[9999]"
      style={{
        bottom: '1.25rem',
        left: '1.25rem',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '9999px',
        background: gradBg,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',

        boxShadow: '0 4px 14px rgba(0,0,0,0.4)',

        pointerEvents: 'auto',
      }}
    >
      <div style={{ position: 'relative', width: `${size}px`, height: `${size}px` }}>
        {                 }
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          style={{ position: 'absolute', inset: 0, transform: 'rotate(-90deg)' }}
        >
          {                  }
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke="rgba(255,255,255,0.12)"
            strokeWidth={strokeWidth}
          />
          {                 }
          <defs>
            <linearGradient id="scrollTopStroke" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#28e3da" stopOpacity={isBottom ? 0.45 : 0.85} />
              <stop offset="100%" stopColor="#28e3da" stopOpacity={isBottom ? 0.2 : 0.35} />
            </linearGradient>
          </defs>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke="url(#scrollTopStroke)"
            strokeWidth={strokeWidth}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 120ms linear' }}
          />
        </svg>

        {                  }
        <div
          style={{
            position: 'absolute',
            width: `${size - 6}px`,
            height: `${size - 6}px`,
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            background: gradBg,
            border: isBottom ? '1px solid #28E3AB' : '1px solid rgba(40,227,218,0.25)',
            boxSizing: 'border-box',
          }}
        />

        {                  }
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke={isBottom ? '#28E3AB' : '#F5FBFF'}
          strokeWidth={isBottom ? '2.2' : '2.4'}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          aria-hidden="true"
        >
          {                                                  }
          <path d="M12 19V7" />
          <path d="M8 11l4-4 4 4" />
        </svg>
      </div>
    </button>
  );
};

export default ScrollToTop;
